var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "101px",
    height: "101px",
    viewBox: "0 0 30 32",
    enableBackground: "new 0 0 30 32",
    xmlSpace: "preserve",
    fill: "#88619a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#88619a",
    d: "M14.898,8.269c-4.149,0-7.524,3.375-7.524,7.524c0,4.148,3.375,7.523,7.524,7.523 c4.148,0,7.523-3.375,7.523-7.523C22.421,11.644,19.046,8.269,14.898,8.269z M14.898,22.316c-3.597,0-6.524-2.926-6.524-6.523 s2.927-6.524,6.524-6.524s6.523,2.927,6.523,6.524S18.495,22.316,14.898,22.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88619a",
    d: "M26.239,24.755C28.77,21.795,30,18.87,30,15.809V0.535c0-0.201-0.12-0.382-0.305-0.46 c-0.184-0.077-0.398-0.039-0.542,0.101c-2.001,1.933-4.58,2.998-7.26,2.998c-2.391,0-4.772-0.88-6.531-2.414 c-0.188-0.164-0.469-0.164-0.657,0c-1.758,1.534-4.16,2.414-6.591,2.414c-3.81,0-7.247-3.016-7.281-3.047 c-0.147-0.13-0.358-0.162-0.537-0.083C0.116,0.125,0,0.303,0,0.5v15.309c0,4.603,2.541,8.863,7.349,12.319 c3.589,2.581,7.123,3.795,7.271,3.845C14.672,31.991,14.727,32,14.781,32c0.051,0,0.102-0.008,0.15-0.023 C15.218,31.886,22.005,29.703,26.239,24.755z M14.787,30.971C13.257,30.408,1,25.582,1,15.809V1.532 c1.322,0.965,4.06,2.641,7.113,2.641c2.521,0,5.018-0.865,6.919-2.386c1.901,1.521,4.376,2.386,6.86,2.386 c2.575,0,5.06-0.892,7.107-2.532v14.168c0,2.812-1.152,5.525-3.521,8.295C21.779,28.429,15.825,30.614,14.787,30.971z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88619a",
    d: "M17.39,12.993l-3.371,3.805l-1.593-2.057c-0.169-0.219-0.483-0.263-0.701-0.094 c-0.218,0.169-0.258,0.472-0.089,0.691l1.962,2.51C13.69,17.966,13.829,18,13.978,18c0.005,0,0.011,0,0.016,0 c0.143,0,0.279-0.019,0.375-0.127l3.771-4.216c0.183-0.207,0.164-0.523-0.043-0.706C17.891,12.769,17.575,12.787,17.39,12.993z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.6a5132f272257bc60d525ef7321230dd.svg";
export { ForwardRef as ReactComponent };